import { createSlice } from '@reduxjs/toolkit';
import { DIAGNOSTICS_PAGE, INTRO_PAGE, PERMISSIONS_INFO_PAGE, SUMMARY_PAGE } from 'UTILS/constants';
import { permissionsError, permissionsRequest } from 'REDUCERS/appSlice';
import { checkList } from 'SRC/store';

const initialState = {
  currentCheck: null,
  currentPage: INTRO_PAGE,
};

const navSlice = createSlice({
  name: 'nav',
  initialState,
  reducers: {
    runCurrentTestAgain() {},
    nextCheck(state) {
      state.currentPage = DIAGNOSTICS_PAGE;
      const currentCheckIndex = state.currentCheck ? checkList.indexOf(state.currentCheck) : -1;
      const newCurrentCheck = checkList[currentCheckIndex + 1];
      if (newCurrentCheck) {
        state.currentCheck = newCurrentCheck;
      } else {
        state.currentPage = SUMMARY_PAGE;
        state.currentCheck = null;
      }
    },
    previousCheck(state) {
      const currentCheckIndex = state.currentCheck ? checkList.indexOf(state.currentCheck) : -1;
      const newCurrentCheck = checkList[currentCheckIndex - 1];
      if (newCurrentCheck) {
        state.currentCheck = newCurrentCheck;
      } else {
        state.currentPage = PERMISSIONS_INFO_PAGE;
        state.currentCheck = null;
      }
      state.currentCheck = newCurrentCheck ?? null;
    },
    goToCheck(state, { payload }) {
      state.currentPage = DIAGNOSTICS_PAGE;
      const newCheckIndex = checkList.indexOf(payload.checkLabel);
      const newCurrentCheck = checkList[newCheckIndex];
      state.currentCheck = newCurrentCheck ?? null;
    },
    goToPermissionsInfo(state) {
      state.currentPage = PERMISSIONS_INFO_PAGE;
    },
    // goToChecks(state) {
    //   state.currentPage = CHECKS_PAGE;
    // },
    goToSummary(state) {
      state.currentPage = SUMMARY_PAGE;
    },
    leaveClick() {},
  },
  extraReducers: (builder) => {
    builder.addCase(permissionsRequest, (state) => {
      state.currentPage = null;
    });
    builder.addCase(permissionsError, (state) => {
      state.currentPage = DIAGNOSTICS_PAGE;
    });
    builder.addDefaultCase(() => {});
  },
});

export const {
  runCurrentTestAgain,
  nextCheck,
  previousCheck,
  goToPermissionsInfo,
  goToCheck,
  goToSummary,
  leaveClick,
} = navSlice.actions;
export default navSlice.reducer;
